import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { DidacticFunctionInterface } from '../+models/DidacticFunction.interface';

export const DIDACTIC_FUNCTION_SERVICE_TOKEN = new InjectionToken('DidacticFunctionService');

export interface DidacticFunctionServiceInterface {
  getAll(): Observable<DidacticFunctionInterface[]>;
  getDidacticFunctions$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: DidacticFunctionInterface[]; count: number }>;
  deleteDidacticFunction$(id: number): Observable<boolean>;
  createDidacticFunction(schoolType: DidacticFunctionInterface): Observable<DidacticFunctionInterface>;
  updateDidacticFunction(schoolType: DidacticFunctionInterface): Observable<DidacticFunctionInterface>;
}
